import * as ng from 'angular';
import { BarChart } from './bar-chart.directive';

export const BarChartModule: string =
    ng.module('bar-chart', [
    ])
        .directive('barChart', BarChart)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/bar-chart/bar-chart.module.ts